import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { VTabModule } from '@sbd-doug-frontend/shared/lib/ui/vtab/vtab.module';
import { NgClass } from '@angular/common';

@Component({
  selector: 'sbd-doug-frontend-common-form-footer',
  standalone: true,
  imports: [
    MatButton,
    MatIcon,
    VTabModule,
    NgClass,
  ],
  templateUrl: './common-form-footer.component.html',
})
export class CommonFormFooterComponent {

  @Input() saveText = 'Save';
  @Input() enableSaveButton = true;
  @Input() saveIcon = 'heroicons_outline:check';
  @Input() saveIconIsSvgIconType = true;
  @Input() rotateSaveIcon = 'heroicons_outline:check';
  @Input() cancelText = 'Cancel';
  @Input() enableCancelButton = true ;
  @Input() cancelIcon = 'heroicons_solid:x-circle';
  @Input() cancelIconIsSvgIconType = true;
  @Input() buttonPosition : 'start' | 'end' |'between' | 'center' = 'between';
  @Input() showSaveButton = true;
  @Input() showCancelButton = true;

  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onSave(): void {
    this.save.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
